import { render, staticRenderFns } from "./CommonLayout.vue?vue&type=template&id=623770b4&scoped=true"
import script from "./CommonLayout.vue?vue&type=script&lang=js"
export * from "./CommonLayout.vue?vue&type=script&lang=js"
import style0 from "./CommonLayout.vue?vue&type=style&index=0&id=623770b4&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623770b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('623770b4')) {
      api.createRecord('623770b4', component.options)
    } else {
      api.reload('623770b4', component.options)
    }
    module.hot.accept("./CommonLayout.vue?vue&type=template&id=623770b4&scoped=true", function () {
      api.rerender('623770b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/CommonLayout.vue"
export default component.exports